import { parseLocalDateString } from '../datetimeTransform';

const formatDate = (dateString: string | null | undefined): string => {
  if (!dateString) return '-';

  const date = parseLocalDateString(dateString);
  if (isNaN(date.getTime())) return '-';

  // Format iso to: "MONTH DATE, YEAR"
  return date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
};

export default formatDate;
